import { pick, get } from 'lodash'

export default function logActionEvent (event = 'pageview', eventOptions = {}) {
  if (window.dataLayer && event === 'pageview') {
    window.dataLayer.push({
      event: 'pageview',
      pagePath: window.location.pathname,
      pageTitle: window.document.title
    })
  }

  const profile = this.user

  const user = pick(profile, ['firstName', 'lastName', 'id', 'email'])
  const currentCompanyId = get(profile, 'currentCompany.id')
  const currentCompanyName = get(profile, 'currentCompany.nameFull')

  if (eventOptions && eventOptions.agree) delete eventOptions.agree

  const data = {
    user: {
      ...user,
      currentCompanyId,
      currentCompanyName
    },
    page: window.location.pathname,
    event,
    eventOptions: JSON.parse(JSON.stringify(eventOptions || {})),
    timestamp: new Date().getTime()
  }

  return axios.post('/log/event', data)
}
